import {Component, Input, OnInit, Output, EventEmitter, OnDestroy} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ProcessoJudicialService} from '../../../../../service/processo/processo-judicial.service';

@Component({
  selector: 'app-cpe-processo',
  templateUrl: './cpe-processo.component.html',
  styleUrls: ['./cpe-processo.component.css']
})
export class CpeProcessoComponent implements OnInit, OnDestroy {
  @Input() formulario: FormGroup;
  @Input() somenteLeitura: boolean = false;
  @Input() numeroProcesso: string;
  @Output() possuiErro = new EventEmitter<boolean>();

  isNotNumber = false;
  isNotValidNumeroProcesso = false;
  numeroDoProcessoValido: boolean;
  numeroDoProcessoInvalido: boolean;


  constructor(private processoService: ProcessoJudicialService) {
  }

  ngOnInit() {
    if (!this.somenteLeitura) {
      this.formulario.addControl('numeroProcesso', new FormControl(this.numeroProcesso, Validators.required));
    }
  }

  ngOnDestroy() {
    if (!this.somenteLeitura) {
      this.formulario.removeControl('numeroProcesso');
    }
  }

  contemErro(str: any) {
    const erros = this.formulario.controls[str].touched &&
      this.formulario.controls[str].errors != null;
    this.possuiErro.emit(this.numeroDoProcessoInvalido);
    return erros;
  }


  maskNumeroProcesso(numeroProcesso: string) {

    let numeroProcessoApenasNumeros = numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (numeroProcessoApenasNumeros.length >= 13 && numeroProcessoApenasNumeros.charAt(13) !== '8') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcessoApenasNumeros.length >= 14 && numeroProcessoApenasNumeros.charAt(14) !== '1') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcessoApenasNumeros.length >= 15 && numeroProcessoApenasNumeros.charAt(15) !== '3') {

      this.isNotValidNumeroProcesso = true;

      return;

    }

    this.isNotValidNumeroProcesso = numeroProcessoApenasNumeros.length > 20;

    if (numeroProcessoApenasNumeros && numeroProcessoApenasNumeros.length >= 20 && numeroProcessoApenasNumeros.length < 25) {

      let resultado: any;
      numeroProcessoApenasNumeros = numeroProcessoApenasNumeros.toString();
      numeroProcessoApenasNumeros = numeroProcessoApenasNumeros.replace('-', '');
      numeroProcessoApenasNumeros = numeroProcessoApenasNumeros.replace('.', '');

      resultado = numeroProcessoApenasNumeros.split('');
      resultado.splice(7, 0, '-');
      resultado.splice(10, 0, '.');
      resultado.splice(15, 0, '.');
      resultado.splice(17, 0, '.');
      resultado.splice(20, 0, '.');
      numeroProcessoApenasNumeros = resultado.join('');

      this.formulario.controls.numeroProcesso.setValue(numeroProcessoApenasNumeros);
    }
  }

  validaNumeroProcesso() {
    const regra = /^[0-9]*$/;
    let numero = '';
    this.numeroDoProcessoValido = false;
    this.numeroDoProcessoInvalido = false;
    if (this.formulario.controls.numeroProcesso.value !== null) {
      numero = this.formulario.controls.numeroProcesso.value.trim().replace(/\./g, '').replace(/-/g, '');
    }

    if (this.formulario.controls.numeroProcesso.value && numero !== '') {

      if (numero.match(regra)) {

        this.isNotNumber = false;

      } else {

        this.isNotNumber = true;
        this.formulario.controls.numeroProcesso.setValue(numero.substring(0, numero.length - 1));
      }
    }
  }

  async buscarProcesso() {
    var qtdeDigitosProcesso = 0;
    if(this.formulario.controls.numeroProcesso.value !== null && this.formulario.controls.numeroProcesso.value !== undefined){
      qtdeDigitosProcesso =  this.formulario.controls.numeroProcesso.value.length;
    }
    if (this.formulario.controls.numeroProcesso && qtdeDigitosProcesso === 20) {

      const processoJudicialPrimeiraInstancia =
        await this.processoService.buscarProcesso(this.formulario.controls.numeroProcesso.value, '1');
      const processoJudicialSegundaInstancia =
        await this.processoService.buscarProcesso(this.formulario.controls.numeroProcesso.value, '2');

      if (processoJudicialPrimeiraInstancia) {
        processoJudicialPrimeiraInstancia.subscribe(() => {
          this.numeroDoProcessoInvalido = false;
          this.numeroDoProcessoValido = true;
        }, () => {

          this.numeroDoProcessoValido = false;
          this.numeroDoProcessoInvalido = true;
        }, () => {
          if (!this.numeroDoProcessoValido) {
            this.numeroDoProcessoInvalido = true;
          }
        });
      }

      if (processoJudicialSegundaInstancia) {

        processoJudicialSegundaInstancia.subscribe(() => {
          this.numeroDoProcessoInvalido = false;
          this.numeroDoProcessoValido = true;
        }, () => {
          this.numeroDoProcessoValido = false;
          this.numeroDoProcessoInvalido = true;
        }, () => {
          if (!this.numeroDoProcessoValido) {
            this.numeroDoProcessoInvalido = true;
          }
        });

      }
      return null;
    }
  }

  formatarNumeroProcesso (valor) {
    if (!valor) return '';
    const tamanho = valor.length;
    const TAMANHO_ESPERADO = 20;

    if (tamanho === TAMANHO_ESPERADO) {
      return valor.replace(
        /^(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})$/,
        '$1-$2.$3.$4.$5.$6'
      );
    }
    return valor;
  };
}
